import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React, { memo, useEffect } from 'react';
import { colors } from "@argo/principles";
import { MyWalletIcon } from "@argo/ui-elements";
import styled from '@emotion/styled';
import triggerImpression from '../../../analytics/react/triggerImpression';
import useAnalytics from '../../../analytics/react/useAnalytics';
var action = colors.action;
var MyWalletBadge = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 10px;\n  padding: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  color: #000000;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: ", ";\n  border-radius: 13px;\n  position: absolute;\n  left: 60%;\n  top: 15%;\n"])), action.gold);
var MyWalletContent = function MyWalletContent(_ref) {
  var _ref$hasNewTradeIn = _ref.hasNewTradeIn,
    hasNewTradeIn = _ref$hasNewTradeIn === void 0 ? false : _ref$hasNewTradeIn,
    _ref$onWalletIconClic = _ref.onWalletIconClick,
    onWalletIconClick = _ref$onWalletIconClic === void 0 ? function () {} : _ref$onWalletIconClic,
    _ref$totalWalletNotif = _ref.totalWalletNotifs,
    totalWalletNotifs = _ref$totalWalletNotif === void 0 ? 0 : _ref$totalWalletNotif,
    walletPopoverContainer = _ref.walletPopoverContainer;
  var analytics = useAnalytics();
  var handleKeyDown = function handleKeyDown(e) {
    if (['Enter', ' '].includes(e.key)) {
      onWalletIconClick(e);
    }
  };
  useEffect(function () {
    if (hasNewTradeIn) {
      triggerImpression(analytics, function (dataLayer) {
        return {
          googleAnalytics: {
            props: {
              event: 'analytics_event',
              eventElement: 'my-wallet',
              eventAction: 'impression',
              eventResult: 'trade-in-indicator',
              eventNonInteractive: false,
              eventData: {
                vehicle: {}
              }
            }
          }
        };
      });
    }
  }, [hasNewTradeIn]);
  return React.createElement("div", {
    onClick: onWalletIconClick,
    role: "button",
    tabindex: "0",
    "aria-label": "My Wallet",
    onKeyDown: handleKeyDown
  }, React.createElement(MyWalletIcon, {
    color: "#FFFFFF"
  }), totalWalletNotifs > 0 && React.createElement(MyWalletBadge, null, totalWalletNotifs), walletPopoverContainer);
};
export default MyWalletContent;